import { jsx, jsxs } from "react/jsx-runtime";
import BrandclubPhoneInput, { BCPhoneInputVariant } from "../BrandclubPhoneInput/index.js";
import { PopupDrawer } from "../PopupDrawer/PopupDrawer.js";
import { useEffect, useState } from "react";
import { RewardTable } from "./RewardTable.js";
import { ArrowLink } from "./ArrowLink.js";
import { BrandclubVideo } from "../BrandclubVideo.js";
import { SharePage } from "./SharePage.js";
import { trackRetailerProductPageEvent, buildTrackingParams } from "../../../utils/analytics.js";
import { getAssetNameFromUrl } from "../../../utils/assetUtils.js";
import { ProductPageDialogSuccess } from "./ProductPageDialogSuccess.js";
import { ProductPageDialogContent } from "./ProductPageDialogContent.js";
import { AnalyticsTrackingEvent } from "../../../analytics/events.js";
const ProductPageDialogMain = ({
  popupDrawerProps: { open, onClose },
  showIcon,
  imageUrl,
  imageSize = 51,
  title,
  secondTitle,
  subtitle,
  phoneInput,
  redirect,
  sharePage,
  sharePageUrl,
  onShareLinkCopied,
  rewardTableRows,
  video,
  Link,
  mainEntity,
  trackingParams,
  retailerPDPNavigationEventParams,
  trackRetailerPDPNavigation,
  analyticsTrack,
  handleSendText,
  userProfile
}) => {
  const [step, setStep] = useState(0);
  const onTextSent = () => setStep(1);
  const handleClose = () => {
    if (step !== 0) {
      setStep(0);
    }
    onClose();
  };
  const trackVideoInteraction = (eventName, additionalEventProps = {}) => {
    const videoId = getAssetNameFromUrl((video == null ? void 0 : video.videoUrl) || "");
    if (videoId && (video == null ? void 0 : video.videoUrl) && trackingParams && mainEntity && analyticsTrack) {
      const eventProps = {
        ...buildTrackingParams({ trackingParams, mainEntity }),
        videoId,
        video: video.videoUrl,
        videoTitle: title,
        ...additionalEventProps
      };
      analyticsTrack(eventName, eventProps);
    }
  };
  const handleVideoPlay = () => {
    trackVideoInteraction(AnalyticsTrackingEvent.LANDING_PAGE_VIDEO_PLAY_STARTED);
  };
  const handleVideoPause = ({ currentTime }) => {
    trackVideoInteraction(AnalyticsTrackingEvent.LANDING_PAGE_VIDEO_PLAY_PAUSED, {
      videoPlayDuration: parseFloat(currentTime.toFixed(2))
    });
  };
  const handleVideoEnd = ({ duration }) => {
    trackVideoInteraction(AnalyticsTrackingEvent.LANDING_PAGE_VIDEO_PLAY_ENDED, {
      videoPlayDuration: parseFloat(duration.toFixed(2))
    });
  };
  const handleTrackRetailerPDPNavigation = () => {
    if (retailerPDPNavigationEventParams && trackingParams && !!analyticsTrack) {
      const params = {
        ...trackingParams,
        ...retailerPDPNavigationEventParams
      };
      trackRetailerProductPageEvent({
        trackingEventAction: "navigateToRetailerProductPage",
        trackingParams: params,
        analyticsTrack
      });
    }
  };
  useEffect(() => {
    let autoRedirectTimeout = void 0;
    if (!!(phoneInput == null ? void 0 : phoneInput.autoRedirectOnSuccess) && (phoneInput == null ? void 0 : phoneInput.redirectionUrl) && step === 1) {
      autoRedirectTimeout = setTimeout(() => {
        window.open(phoneInput == null ? void 0 : phoneInput.redirectionUrl);
      }, 2e3);
    }
    return () => {
      if (autoRedirectTimeout) {
        clearTimeout(autoRedirectTimeout);
      }
    };
  }, [phoneInput == null ? void 0 : phoneInput.autoRedirectOnSuccess, phoneInput == null ? void 0 : phoneInput.redirectionUrl, step]);
  return /* @__PURE__ */ jsx(PopupDrawer, { open, onClose: handleClose, children: step === 0 ? /* @__PURE__ */ jsxs(
    ProductPageDialogContent,
    {
      title,
      secondTitle,
      subtitle,
      showIcon,
      imageUrl,
      imageSize,
      sx: {
        paddingBottom: `${sharePage && video ? "30" : "48"}px`
      },
      children: [
        phoneInput && handleSendText && /* @__PURE__ */ jsx("div", { className: "phone-input-container", children: /* @__PURE__ */ jsx(
          BrandclubPhoneInput,
          {
            userProfile,
            hasHeader: false,
            buttonText: "Get App",
            variant: BCPhoneInputVariant.SM,
            onTextSent,
            handleSendText
          }
        ) }),
        redirect && /* @__PURE__ */ jsx(
          ArrowLink,
          {
            ...{
              text: redirect.text,
              url: redirect.url,
              onTextClick: () => {
                if (trackRetailerPDPNavigation) {
                  handleTrackRetailerPDPNavigation();
                }
                window.open(redirect.url, "_blank");
              }
            }
          }
        ),
        sharePage && /* @__PURE__ */ jsx("div", { className: "share-container", children: /* @__PURE__ */ jsx(SharePage, { url: sharePageUrl || window.location.href, onShareLinkCopied }) }),
        rewardTableRows && /* @__PURE__ */ jsx(RewardTable, { rows: rewardTableRows, containerStyle: { marginTop: 10 } }),
        video && /* @__PURE__ */ jsx("div", { className: "video-container", style: { margin: `${sharePage && video ? "0" : "12"}px auto 0` }, children: /* @__PURE__ */ jsx(
          BrandclubVideo,
          {
            videoUrl: video.videoUrl,
            posterUrl: video.coverImageUrl,
            canPlay: true,
            onPlay: handleVideoPlay,
            onPause: handleVideoPause,
            onEnd: handleVideoEnd
          }
        ) })
      ]
    }
  ) : /* @__PURE__ */ jsx(
    ProductPageDialogSuccess,
    {
      handleClose,
      closeDialogText: phoneInput == null ? void 0 : phoneInput.closeDialogText,
      redirectionText: phoneInput == null ? void 0 : phoneInput.redirectionText,
      redirectionUrl: Link ? phoneInput == null ? void 0 : phoneInput.redirectionUrl : void 0
    }
  ) });
};
const ProductPageDialog = (props) => {
  const location = window.location;
  useEffect(() => {
    props.popupDrawerProps.open && props.popupDrawerProps.onClose();
  }, [location]);
  return /* @__PURE__ */ jsx(ProductPageDialogMain, { ...props });
};
export {
  ProductPageDialog,
  ProductPageDialogMain
};
//# sourceMappingURL=ProductPageDialog.js.map
